export default "__VITE_ASSET__1ljXIyC1__"